module.exports = __webpack_public_path__ + "img/main_title2026.d84a6eb3.png";